<template>
    <b-container fluid>
        <div
            v-sticky="{zIndex: 12, stickyTop: 55}"
            class="bg-white py-3"
        >
            <div class="d-md-flex align-items-center m-0">
                <div class="h3 mb-3 mr-3">
                    Admin
                </div>
            </div>
            <div>
                <b-tabs content-class="mt-3" no-fade>
                    <UsersTab />
                    <RolesTab />
                    <PermissionsTab />
                </b-tabs>
            </div>
        </div>
    </b-container>
</template>

<style></style>

<script>
import VueSticky from 'vue-sticky'
import { mapState } from 'vuex'
import UsersTab from '@/components/admin/UsersTab.vue'
import RolesTab from '@/components/admin/RolesTab.vue'
import PermissionsTab from '@/components/admin/PermissionsTab.vue'

export default {
    name: 'Admin',
    components: {
        UsersTab,
        RolesTab,
        PermissionsTab,
    },
    directives: {
        'sticky': VueSticky,
    },
    computed: {
        ...mapState({
            errors: state => state.errors.errors,
            user: state => state.user.user,
        }),
    },
}
</script>
